import React from 'react';
import ActionModal, { ActionModalFooter } from 'common-components/modal/ActionModal';
import { Paragraph } from 'common-components/typography';
import { Col, Row } from 'antd';
import { PrimaryButton, SecondaryButton } from 'common-components/buttons';

interface IDeleteCustomerFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}
const DeleteCustomerFormModal = ({ isOpen, onClose, onDelete }: IDeleteCustomerFormModalProps) => {
  return (
    <>
      <ActionModal isOpen={isOpen} title={'Remove form'} onClose={onClose}>
        <Paragraph>Are you sure you want to remove this form.</Paragraph>
        <Paragraph>This action is permanent.</Paragraph>

        <ActionModalFooter className={'mt-large'}>
          <Row type={'flex'} className={'justify-end'}>
            <Col className="mr-medium">
              <SecondaryButton size="large" onClick={onClose}>
                Cancel
              </SecondaryButton>
            </Col>
            <Col>
              <PrimaryButton onClick={onDelete} size="large">
                Remove
              </PrimaryButton>
            </Col>
          </Row>
        </ActionModalFooter>
      </ActionModal>
    </>
  );
};

export default DeleteCustomerFormModal;
